module.exports = __webpack_public_path__ + "01ea978f/img/question-icon.06c20c5d.svg";